// VehiclesSlice.ts
import { type PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import useFleetApi from '../data/fleetApi';
import { type Vehicle } from '../domain/vehicle';

export const fetchVehicles = createAsyncThunk(
    'vehicles/fetchVehicles',
    async (_, { dispatch }) => {
        const { apiGetVehicles } = useFleetApi();
        const response = await apiGetVehicles();
        dispatch(setVehicles(response.data));
        return response.data;
    }
);

const initialState: Vehicle[] = [];

const vehiclesSlice = createSlice({
    initialState,
    name: 'vehicles',
    reducers: {
        clearVehicles: () => initialState,
        setVehicles: (state, action: PayloadAction<Vehicle[]>) => action.payload,
    },
});

export const { setVehicles, clearVehicles } = vehiclesSlice.actions;
export default vehiclesSlice.reducer;

export const initializeVehicles = () => fetchVehicles();